import React, { Component } from 'react';
import classNames from 'classnames';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import ViewVideo from '../components/viewVideo';
import ButtonBases from '../components/ButtonBases'
import api from '../api/backend'

import courseImage from '../assets/img/course.png'
import profile from '../assets/img/profile.png'

import ReactGA from 'react-ga';

const styles = theme => ({
    heroContent: {
        // maxWidth: 600,
        // margin: '0 auto',
        // padding: `${theme.spacing.unit * 8}px 0 ${theme.spacing.unit * 6}px`,
    },
    layout: {
        width: 'auto',
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(1100 + theme.spacing.unit * 3 * 2)]: {
            width: 1100,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    cardGrid: {
        padding: `${theme.spacing.unit * 8}px 0`,
    },
    cardMedia: {
        paddingTop: '25.25%', // 16:9
    },
    cardContent: {
        flexGrow: 1,
    },
    card: {
        marginBottom: 50,
        height: 200
    },
    paper: {
        margin: theme.spacing.unit * 2,
        padding: theme.spacing.unit * 2,
    },
});

class Course extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = { course: { course: {}, instructor: {} }, videos: [], myCourses: [], open: false, loading: false }
    }

    getCourse = (id) => {
        return api.getCourse(id).then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                this.setState({ course: json })
                ReactGA.initialize('UA-141674580-1')
                ReactGA.event({
                    category: 'Course',
                    action: `Open Course [${json.title}]`
                })
            } else {
                console.error(`ไม่สามารถรับค่าจากคอร์ส ${id} ได้`)
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
        })
    }

    getMyCourse = () => {
        return api.getMyCourse().then(([response, json]) => {
            if (response.status === 200) {
                this.setState({ myCourses: json })
            } else {
                console.error(`ไม่สามารถรับค่าจากคอร์สของฉันได้`)
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
        })
    }

    getVideos = (id) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        return api.getVideos(id, user.userName).then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                this.setState({ videos: json })
            } else {
                console.error(`ไม่สามารถรับค่าจากคอร์ส ${id} ได้`)
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
        })
    }

    loadAll = (id) => {
        this.setState({ loading: true })
        Promise.all([
            this.getCourse(id),
            this.getMyCourse(),
            this.getVideos(id),
        ]).finally(() => {
            this.setState({ loading: false })
        })
    }

    fancyTimeFormat(time) {
        // Hours, minutes and seconds
        var hrs = ~~(time / 3600);
        var mins = ~~((time % 3600) / 60);
        var secs = ~~time % 60;

        // Output like "1:01" or "4:03:59" or "123:03:59"
        var ret = "";

        if (hrs > 0) {
            ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
        }

        ret += "" + mins + ":" + (secs < 10 ? "0" : "");
        ret += "" + secs;
        return ret;
    }

    fancyTimeFormat2(videos) {
        let time = 0;
        videos.forEach(element => {
            time += element.duration
        });
        // Hours, minutes and seconds
        var hrs = ~~(time / 3600);
        var mins = ~~((time % 3600) / 60);
        var secs = ~~time % 60;

        if (hrs > 0) {
            return `${hrs} ชั่วโมง ${mins} นาที`;
        } else {
            return `${mins} นาที ${secs} วินาที`;
        }
    }

    checkMyCourse = () => {
        const { myCourses } = this.state
        const { match } = this.props
        const index = myCourses.findIndex(i => i.course.id === parseInt(match.params.id, 10))
        if (index > -1) {
            return myCourses[index]
        } else {
            return null
        }
    }

    isAdmin = () => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        return user && user.userName === 'admin'
    }

    registerCourse = (type) => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const { match } = this.props
        api.createMyCourse(parseInt(match.params.id, 10), { paymentStatus: 'Inprogress', user: user.userName, type }).then(([response]) => {
            if (response.status === 200) {
                this.getCourse(match.params.id)
                this.getMyCourse()
                this.getVideos(match.params.id)
                this.setState({ open: false })
            } else {
                console.error('ไม่สามารถเพิ่มคอร์สได้')
                this.setState({ open: false })
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
            this.setState({ open: false })
        })
    }

    componentDidMount() {
        this.loadAll(this.props.match.params.id)
    }

    componentDidUpdate(prevProps) {
        const newId = this.props.match.params.id
        if (prevProps.match.params.id !== newId) {
            this.setState({ videos: [], course: { course: {}, instructor: {} } })
            this.loadAll(newId)
        }
    }
    render() {
        const { classes, match } = this.props
        const { videos, loading } = this.state
        const { course, instructor } = this.state.course
        const myCourse = this.checkMyCourse()
        const isAdmin = this.isAdmin()
        const canViewVideos = isAdmin || (myCourse && myCourse.paymentStatus !== 'Inprogress')

        videos.sort(function (a, b) {
            var nameA = a.video.title.trim().toUpperCase();
            var nameB = b.video.title.trim().toUpperCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        })

        return (
            <main style={{ paddingTop: 64 }}>
                {/* <div className={classes.heroContent}>
                    <Typography variant="display2" align="center" color="textPrimary" gutterBottom>
                        {course.title}
                    </Typography>
                </div> */}
                <div className={classes.heroContent}>
                    {isAdmin || myCourse ?
                        <ButtonBases title={course.title} big={true} url={courseImage} /> :
                        <ButtonBases main={course.title} title='ลงทะเบียนเรียน' big={false} onClick={() => this.setState({ open: true })} url={courseImage} />}
                </div>
                {loading && (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '80px 0' }}>
                        <CircularProgress size={80} thickness={4} />
                        <Typography variant="title" color="textSecondary" style={{ marginTop: 24 }}>
                            กำลังโหลด...
                        </Typography>
                    </div>
                )}
                <div className={classNames(classes.layout)} style={{ display: loading ? 'none' : 'block' }}>
                    <Grid container spacing={24}>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="subheading" color="textPrimary">
                                {/* เนื้อหา {videos.length} วีดีโอ | ความยาว {this.fancyTimeFormat2(videos)} */}
                                เนื้อหา {videos.length} วีดีโอ
                            </Typography>
                            <br />
                            {canViewVideos ? videos.map(video => (<Paper className={classes.paper} elevation={1} key={video.video.id}>
                                <Grid container wrap="nowrap" spacing={16}>
                                    <ViewVideo videoId={video.video.id} path={video.video.path} disabled={!isAdmin && video.histories.length >= myCourse.count} title={video.video.title} duration={video.video.duration} onAddHistory={() => this.getVideos(match.params.id)} />
                                    <Grid item xs>
                                        <Typography component="p" noWrap>
                                            {video.video.title}
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        {isAdmin
                                            ? <Typography variant="caption">Admin</Typography>
                                            : <Typography variant="caption">จำนวนครั้ง ({video.histories.length}/{myCourse.count})</Typography>}
                                    </Grid>
                                </Grid>
                            </Paper>)) : myCourse ? <Paper style={{ backgroundColor: '#f8982b', padding: 20 }} elevation={1}>
                                <Typography component="p" variant="subheading" noWrap style={{ color: 'white' }}>
                                    อยู่ระหว่างรอการอนุมัติการลงทะเบียน
                                </Typography>
                            </Paper> : <Paper style={{ backgroundColor: '#f8982b', padding: 20 }} elevation={1}>
                                <Typography component="p" variant="subheading" noWrap style={{ color: 'white' }}>
                                    ยังไม่ได้ลงทะเบียนเรียนวิชานี้
                                </Typography>
                                <br />
                                <Typography component="p" variant="subheading" noWrap style={{ color: 'white' }}>
                                    <Button variant="outlined" onClick={() => this.setState({ open: true })} style={{ color: 'white', borderColor: 'white' }}>คลิกที่นี่เพื่อลงทะเบียน</Button>
                                </Typography>
                            </Paper>}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="title" color="textPrimary" >
                                รายละเอียดคอร์ส
                                </Typography>
                            <Typography variant="body1" color="textPrimary" style={{ whiteSpace: 'pre-line', paddingTop: 30 }}>
                                {course.description}
                            </Typography>
                            <Grid container wrap="nowrap" spacing={16} style={{ paddingTop: 50 }}>
                                <Grid item>
                                    <Avatar aria-label="Recipe" className={classes.avatar} src={profile} />
                                </Grid>
                                <Grid item xs>
                                    {instructor ? <Typography variant="subheading">{`${instructor.firstName} ${instructor.lastName}`}</Typography> :
                                        <Typography variant="subheading">{`${course.instructor}`}</Typography>}
                                    <Typography variant="caption">Tutor + Instructor</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>

                <Dialog
                    open={this.state.open}
                    onClose={() => this.setState({ open: false })}
                    aria-labelledby="draggable-dialog-title"
                >
                    <DialogTitle id="draggable-dialog-title">ลงทะเบียนเรียน</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            ลงทะเบียนเรียนแบบออนไลน์เท่านั้น หรือแบบเรียนสด + เรียนออนไลน์
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.registerCourse('เรียนออนไลน์')} color="primary">
                            ลงเรียนออนไลน์
                        </Button>
                        <Button onClick={() => this.registerCourse('เรียนออนไลน์+เรียนสด')} color="primary">
                            ลงเรียนออนไลน์ + เรียนสด
                        </Button>
                    </DialogActions>
                </Dialog>
            </main>
        );
    }
}

export default withStyles(styles)(Course);